/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceInvitationDto
 */
export interface DeviceInvitationDto {
    /**
     *
     * @type {number}
     * @memberof DeviceInvitationDto
     */
    deviceInvitationId?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceInvitationDto
     */
    code?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceInvitationDto
     */
    message?: string;
    /**
     *
     * @type {Array<number>}
     * @memberof DeviceInvitationDto
     */
    deviceInstallationIds?: Array<number>;
    /**
     *
     * @type {string}
     * @memberof DeviceInvitationDto
     */
    deviceAccessLevel?: DeviceInvitationDtoDeviceAccessLevelEnum;
    /**
     *
     * @type {Date}
     * @memberof DeviceInvitationDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceInvitationDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceInvitationDto
     */
    expiresAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceInvitationDto
     */
    acceptedAt?: Date;
    /**
     *
     * @type {number}
     * @memberof DeviceInvitationDto
     */
    acceptedLimit?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceInvitationDto
     */
    acceptedCount?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceInvitationDto
     */
    type?: DeviceInvitationDtoTypeEnum;
    /**
     *
     * @type {number}
     * @memberof DeviceInvitationDto
     */
    accessDurationSeconds?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceInvitationDto
     */
    createdByUserAccountId?: number;
}

/**
 * @export
 */
export const DeviceInvitationDtoDeviceAccessLevelEnum = {
    Owner: "Owner",
    SecondaryUser: "SecondaryUser",
} as const;
export type DeviceInvitationDtoDeviceAccessLevelEnum =
    (typeof DeviceInvitationDtoDeviceAccessLevelEnum)[keyof typeof DeviceInvitationDtoDeviceAccessLevelEnum];

/**
 * @export
 */
export const DeviceInvitationDtoTypeEnum = {
    DeviceOwnerVerification: "DeviceOwnerVerification",
    InstallerDeviceInvite: "InstallerDeviceInvite",
    SimpleDeviceInvite: "SimpleDeviceInvite",
    BillingDeviceInvite: "BillingDeviceInvite",
} as const;
export type DeviceInvitationDtoTypeEnum =
    (typeof DeviceInvitationDtoTypeEnum)[keyof typeof DeviceInvitationDtoTypeEnum];

/**
 * Check if a given object implements the DeviceInvitationDto interface.
 */
export function instanceOfDeviceInvitationDto(
    value: object,
): value is DeviceInvitationDto {
    return true;
}

export function DeviceInvitationDtoFromJSON(json: any): DeviceInvitationDto {
    return DeviceInvitationDtoFromJSONTyped(json, false);
}

export function DeviceInvitationDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceInvitationDto {
    if (json == null) {
        return json;
    }
    return {
        deviceInvitationId:
            json["deviceInvitationId"] == null
                ? undefined
                : json["deviceInvitationId"],
        code: json["code"] == null ? undefined : json["code"],
        message: json["message"] == null ? undefined : json["message"],
        deviceInstallationIds:
            json["deviceInstallationIds"] == null
                ? undefined
                : json["deviceInstallationIds"],
        deviceAccessLevel:
            json["deviceAccessLevel"] == null
                ? undefined
                : json["deviceAccessLevel"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        expiresAt:
            json["expiresAt"] == null ? undefined : new Date(json["expiresAt"]),
        acceptedAt:
            json["acceptedAt"] == null
                ? undefined
                : new Date(json["acceptedAt"]),
        acceptedLimit:
            json["acceptedLimit"] == null ? undefined : json["acceptedLimit"],
        acceptedCount:
            json["acceptedCount"] == null ? undefined : json["acceptedCount"],
        type: json["type"] == null ? undefined : json["type"],
        accessDurationSeconds:
            json["accessDurationSeconds"] == null
                ? undefined
                : json["accessDurationSeconds"],
        createdByUserAccountId:
            json["createdByUserAccountId"] == null
                ? undefined
                : json["createdByUserAccountId"],
    };
}

export function DeviceInvitationDtoToJSON(
    value?: DeviceInvitationDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceInvitationId: value["deviceInvitationId"],
        code: value["code"],
        message: value["message"],
        deviceInstallationIds: value["deviceInstallationIds"],
        deviceAccessLevel: value["deviceAccessLevel"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        expiresAt:
            value["expiresAt"] == null
                ? undefined
                : value["expiresAt"].toISOString(),
        acceptedAt:
            value["acceptedAt"] == null
                ? undefined
                : value["acceptedAt"].toISOString(),
        acceptedLimit: value["acceptedLimit"],
        acceptedCount: value["acceptedCount"],
        type: value["type"],
        accessDurationSeconds: value["accessDurationSeconds"],
        createdByUserAccountId: value["createdByUserAccountId"],
    };
}
